module.exports = __webpack_public_path__ + "img/themeOn.75ea2814.svg";